import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';
import style from '../../Styles/AddUser.module.css';

/**
 * Reusable BackButton — navigates to the previous page via navigate(-1).
 * Matches the same look-and-feel used in AddUserRole.js
 */
const BackButton = () => {
  const navigate = useNavigate();

  return (
    <div
      className={`${style['arrow-icon']} border px-2 pb-1`}
      onClick={() => navigate(-1)}
      title="Go Back"
    >
      <FaArrowLeft />
    </div>
  );
};

export default BackButton;
